import { Box, Typography, Button } from '@mui/material';
import { white } from '@styles/colors';

const AccessDenied = () => {

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                p: 2,
                backgroundColor: white,
            }}
        >
            <Typography
                variant="h1"
                component="h1"
                sx={{ fontSize: { xs: '4rem', md: '6rem' }, fontWeight: 'bold' }}
            >
                Access Denied
            </Typography>
            <Typography
                variant="h6"
                sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' }, mb: 2 }}
            >
                You have no access for this page
            </Typography>
        </Box>
    );
};

export default AccessDenied;
